<template>
  <div>
    <form class="box box--no-color form form--inline">
      <div>
        <h3 class="form__title">{{ $t('chart.period') }}:</h3>
        <div class="input--inline">
          <label class="label">{{ $t('chart.date.from') }}</label>
          <datepicker
            :format="$t('date.simpleFormat')"
            :language="datepickerLanguage[i18n.locale]"
            v-model="filters.start"
            :use-utc="true">
          </datepicker>
        </div>
        <div class="input--inline">
          <label class="label">{{ $t('chart.date.to') }}</label>
          <datepicker
            :format="$t('date.simpleFormat')"
            :language="datepickerLanguage[i18n.locale]"
            v-model="filters.end"
            :use-utc="true">
          </datepicker>
        </div>
      </div>
      <div class="tab tab--bordered align-center">
        <label class="tab__item">
          <input type="radio" v-model="filters.granularity" value="hour">
          <span class="tab__text">{{ $t('chart.granularity.hour.label') }}</span>
        </label>

        <label class="tab__item">
          <input type="radio" v-model="filters.granularity" value="day">
          <span class="tab__text">{{ $t('chart.granularity.day.label') }}</span>
        </label>
      </div>
      <span class="button button--gradient-blue" type="button" @click="filterChart()">
        {{ $t('chart.filter') }}
      </span>
    </form>
    <line-chart class="box box--no-color" v-if="loaded"></line-chart>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Notify from 'klicknotify';
import { en, es, ptBR } from 'vuejs-datepicker/dist/locale';
import Datepicker from 'vuejs-datepicker';
import i18n from '../../../../i18n';
import dateHelper from '../../../../services/date';
import LineChart from './LineChart';


export default {
  props: {
    pageIdentifier: {
      type: String,
      require: true,
    },
  },
  created() {
    this.getChartData({ pageIdentifier: this.pageIdentifier, filters: this.filters }).then(() => {
      this.loaded = true;
    });
  },
  components: {
    LineChart,
    Datepicker,
  },
  data() {
    return {
      datepickerLanguage: { en, es, 'pt-BR': ptBR },
      i18n,
      filters: {
        start: dateHelper.subtractDays(dateHelper.today(), 7),
        end: dateHelper.today(),
        granularity: 'day',
      },
      loaded: false,
    };
  },
  computed: mapGetters({
    chart: 'metrics/chart',
  }),
  methods: {
    filterChart() {
      if (dateHelper.isInvalidPeriod(this.filters.start, this.filters.end)) {
        Notify.error({ message: this.$t('chart.date.invalidPeriod'), autoHide: true });
        return;
      }
      this.filters.start = dateHelper.truncate(this.filters.start);
      this.filters.end = dateHelper.truncate(this.filters.end);
      this.getChartData({ pageIdentifier: this.pageIdentifier, filters: this.filters });
    },
    ...mapActions({
      getChartData: 'metrics/getChartData',
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/screens/Metrics/components/charts/Chart.vue